import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { initialize, reduxForm, Field, FieldArray, formValueSelector, change, reset } from 'redux-form';
import { connect } from 'react-redux';
import billingValidation from './billingValidation';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import StripeCardBillingForm from './StripeCardBillingForm';
import StripeACHBillingForm from './StripeACHBillingForm';
import { SecondaryButton, Spinner } from 'components';
import * as styles from './BillingForm.scss';
var BillingForm = (_dec = reduxForm({
  form: 'billing'
}), _dec2 = connect(function (state) {
  var billingFormSelector = formValueSelector('billing');
  return {
    contract: state.contract,
    billingError: state.billing.billingError,
    monthsPaidFor: billingFormSelector(state, 'monthsPaidFor'),
    checkoutInProgress: state.billing.checkoutInProgress
  };
}, {
  initialize: initialize
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(BillingForm, _Component);

  var _super = _createSuper(BillingForm);

  // eslint-disable-line react/prefer-stateless-function
  function BillingForm(props) {
    var _this;

    _classCallCheck(this, BillingForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderForm", function () {
      var contract = _this.props.contract; //    const paymentMethodName = contract.PaymentMethod.name.toLowerCase();

      var paymentMethodName = 'stripe credit card';

      if (paymentMethodName === 'stripe credit card') {
        return /*#__PURE__*/React.createElement(StripeCardBillingForm, null);
      } else if (paymentMethodName === 'stripe ach') {
        return /*#__PURE__*/React.createElement(StripeACHBillingForm, null);
      }

      return null;
    });

    _this.state = {
      payAdditionalMonths: false
    };
    return _this;
  }

  _createClass(BillingForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contract = _this$props.contract,
          handleSubmit = _this$props.handleSubmit,
          showTotal = _this$props.showTotal,
          billingError = _this$props.billingError,
          checkoutInProgress = _this$props.checkoutInProgress,
          isBusy = _this$props.isBusy;
      var errorText = billingError && billingError.message && billingError.message.message ? billingError.message.message : billingError || '';
      var total = null;

      if (!contract.isPartner && showTotal) {
        total = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
          className: styles.billingHeader,
          style: {
            marginBottom: 12,
            marginTop: 36
          }
        }, "Total Due"), /*#__PURE__*/React.createElement("h3", null, "Total due today: $", this.props.getTotalDueToday(), ".00"));
      } else if (contract.isPartner && showTotal) {
        total = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
          className: styles.billingHeader,
          style: {
            marginBottom: 12,
            marginTop: 36
          }
        }, "Total Due"), /*#__PURE__*/React.createElement("h3", null, "Total due today: $", this.props.getTotalDueTodayPartner(contract.ContractPartners[0]), ".00"));
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
        id: "billingForm",
        className: "form-horizontal",
        onSubmit: handleSubmit,
        style: {
          position: 'relative'
        }
      }, this.renderForm(), /*#__PURE__*/React.createElement("div", null, this.props.showTotal && total, /*#__PURE__*/React.createElement("span", {
        className: styles.paymentErrors
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-icon fa-icon-cross"
      }), errorText)), /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: 80,
          position: 'relative'
        }
      }, checkoutInProgress || isBusy ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(SecondaryButton, {
        type: "submit",
        label: "Submit"
      }))));
    }
  }]);

  return BillingForm;
}(Component), _defineProperty(_class2, "propTypes", {
  active: PropTypes.string,
  asyncValidating: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  dirty: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired
}), _defineProperty(_class2, "defaultProps", {
  showTotal: true
}), _temp)) || _class) || _class);
export { BillingForm as default };